import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--input", {
  height: units.px(40),
  width: "100%",
  maxWidth: "100%",
  fontSize: units.px(18)
});
const wrapper = "_35sw11sr9yl";
const input = "_35si96duc7";
const pencil = "_35sp77bvb1";
const icon = "_35siorrza0";

export { icon, input, pencil, tokens, wrapper };
import "./atom.textarea-input.style.linaria.module.css";
//# sourceMappingURL=atom.textarea-input.style.js.map
